import * as React from 'react';
import * as Actions from './Actions';
import { getDeliveredImagesGalleryList } from './Reducer';
import ImageGallery from 'react-image-gallery';
import { useDispatch, useSelector } from 'react-redux';
import {
    CustomRightNav,
    CustomLeftNav,
    CustomFullscreen,
    CustomPlayPause
} from './CustomNavigationButtons';

export type DeliveredImagesGalleryPageProps = {
    reference: string;
};

type Image = {
    filename: string;
    reference: string;
};

type Images = {
    list: Image[];
};

export const DeliveredImagesGalleryPage = ({ images }) => {
    const [play, setPlay] = React.useState<boolean>(false);
    const [showPlayBtn, setShowPlayBtn] = React.useState<boolean>(false);
    const [fullscreen, setFullscreen] = React.useState<boolean>(false);
    const refImg = React.useRef(null);

    const mobileScreen = window.innerWidth < 900;

    const getSlideDuration = () => {
        if (mobileScreen && !play) {
            return 450;
        }
        if (mobileScreen && play) {
            return 1000;
        }
        return 1700;
    };

    return images.length > 0 ? (
        <div className={'image-gallery-wrapper' + (play ? ' play' : '') + (fullscreen ? ' fullscreen' : '')}
            onClick={(e) => {
                const target = e.target as Element;

                if (play && target.parentElement.classList.contains('image-gallery-image')) {
                    setPlay(false);
                    refImg.current.pause();
                }

                if (!play && target.parentElement.classList.contains('image-gallery-image')) {
                    setShowPlayBtn(true);
                }

                if (!play && showPlayBtn) {
                    setShowPlayBtn(false);
                }
            }}>
            <ImageGallery
                ref={refImg}
                autoPlay={false}
                items={images}
                slideInterval={5000}
                slideDuration={getSlideDuration()}
                slideOnThumbnailOver={false}
                showThumbnails={(fullscreen == true && play == true) ? false : true}
                showNav={!play}
                renderRightNav={(leftNavOnClick, disabled) => (
                    <CustomRightNav onClick={leftNavOnClick} disabled={disabled} />
                )}
                renderLeftNav={(leftNavOnClick, disabled) => (
                    <CustomLeftNav onClick={leftNavOnClick} disabled={disabled} />
                )}
                renderFullscreenButton={(onClick, isFullscreen) => (
                    <CustomFullscreen onClick={onClick} isFullscreen={isFullscreen} setFullscreen={setFullscreen} />
                )}
                renderPlayPauseButton={(onClick, isPlaying) => (
                    <CustomPlayPause onClick={onClick} isPlaying={isPlaying} setPlay={setPlay} showPlayBtn={showPlayBtn} mobileScreen={mobileScreen} />
                )}
            />
        </div>
    ) : null;
};

const DeliveredImagesGalleryDataLayer = (props: DeliveredImagesGalleryPageProps) => {
    let { reference } = props;
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(Actions.getImages(reference));
    }, [dispatch]);

    let list = useSelector((state) => getDeliveredImagesGalleryList(state));

    const { apiUrl } = window.appConfig;

    let images: Images =
        list.length > 0
            ? list.map((x) => {
                return {
                    original: `${apiUrl}/file/${x.reference}`,
                    thumbnail: `${apiUrl}/file/${x.reference}`
                };
            })
            : [];

    return <DeliveredImagesGalleryPage {...props} images={images} />;
};

export default DeliveredImagesGalleryDataLayer;
